/**
 * @module RetryPromotionsService
 * @remarks RTK Query service for fetching user retry_promotions data
 */

import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

/**
 * Interface for retry promotions response
 */
interface RetryPromotionsResponse {
  id: number;
  sequence: number;
  createdAt: string;
  createdBy: string;
  modifiedAt: string;
  modifiedBy: string;
  fields: {
    retry_promotions: boolean;
  };
}

/**
 * API service for fetching user retry promotions data
 */
export const retryPromotionsApi = createApi({
  reducerPath: "retryPromotionsApi",
  baseQuery: fetchBaseQuery({
    baseUrl: "/api/",
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("auth_token");
      if (token) {
        headers.set("Authorization", token);
      }
      return headers;
    },
  }),
  tagTypes: ["RetryPromotions"],
  endpoints: (builder) => ({
    getRetryPromotions: builder.query<boolean, string>({
      query: (userId) => ({
        url: `data/users/${userId}`,
        method: "PATCH",
        body: {
          fields: {
            retry_promotions: true
          }
        },
      }),
      // Transform response to extract retry_promotions boolean value
      transformResponse: (response: RetryPromotionsResponse[]) => {
        return response[0]?.fields?.retry_promotions || false;
      },
      providesTags: ["RetryPromotions"],
    }),
  }),
});

// Export hooks for use in components
export const { useGetRetryPromotionsQuery, useLazyGetRetryPromotionsQuery } = retryPromotionsApi;